import React from 'react';
import { Field, Form } from 'formik';
import FormikInputField from 'components/Fields/FormikInputField';
import LoadingButton from 'components/common/LoadingButton';

const PrivacyPolicyForm = (props) => {
  const { handleSubmit, isSubmitting, isValid, dirty } = props;
  return (
    <Form onSubmit={handleSubmit}>
      <Field
        name="settingValue"
        type="textarea"
        label=""
        className="border-field cms-field"
        component={FormikInputField}
      />
      <div className="form-btn d-flex justify-content-end mt-4">
        <LoadingButton
          className="mw-100 loading-button"
          loading={isSubmitting}
          disabled={!isValid || !dirty || isSubmitting}
          color="warning"
          size="sm"
          type="submit"
        >
          Save
        </LoadingButton>
      </div>
    </Form>
  );
};

export default PrivacyPolicyForm;
